function forceRegisterPolyfill() {
	Object.defineProperty(Set.prototype, "intersection", {
		configurable: true,
		enumerable: false,
		value<T>(this: Set<T>, other: Iterable<T> | { has(value: T): boolean }): Set<T> {
			if (this == null) {
				throw new TypeError("Set.prototype.intersection called on null or undefined")
			}

			const otherHas =
				typeof (other as { has?: unknown }).has === "function"
					? (value: T) => (other as { has(value: T): boolean }).has(value)
					: (() => {
							const otherSet = new Set(other as Iterable<T>)
							return (value: T) => otherSet.has(value)
						})()

			const result = new Set<T>()
			for (const value of this) {
				if (otherHas(value)) {
					result.add(value)
				}
			}

			return result
		},
		writable: true,
	})
}

// Exported for test coverage measurement
function initializePolyfill(): boolean {
	if (typeof Set.prototype.intersection !== "function") {
		forceRegisterPolyfill()
		return true
	}
	return false
}

// Register polyfill if native implementation doesn't exist
initializePolyfill()
